import gql from "graphql-tag";

export function crewListQuery(params) {
    return {
        query: gql`
            query($id: ID!) {
                result: product(id: $id) {
                    ... on Feature {
                        crew {
                            name
                            role
                        }

                    }
                    ... on Season {
                        crew {
                            name
                            role
                        }
                    }
                }
            }
        `,
        variables: params,
    };
}
